import { getContents, getContentById } from '../services/napi';
import {
  CONTENT_FETCH_SUCCESS,
  CONTENT_FETCH_FAIL,
  CONTENT_FETCH_BY_ID_SUCCESS,
  CONTENT_FETCH_BY_ID_FAIL,
  CONTENT_SET_DRAFT
} from '../constant/actionType';

function fetchContentError() {
  return {
    error: 'CONTENT_FETCH_FAIL',
    type: CONTENT_FETCH_FAIL
  };
}

function fetchContentByIdError() {
  return {
    error: 'CONTENT_FETCH_BY_ID_FAIL',
    type: CONTENT_FETCH_BY_ID_FAIL
  };
}

export function fetchContent(current, limit, searchItem, customTypeId) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;

      const response = await getContents(projectId, current, limit, searchItem, customTypeId);

      dispatch({ data: response.data, type: CONTENT_FETCH_SUCCESS });
    } catch (error) {
      dispatch(fetchContentError());
    }
  };
}

export function fetchContentById(id, updateDraft = false) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;

      const response = await getContentById(id, projectId);
      dispatch({ data: response.data, type: CONTENT_FETCH_BY_ID_SUCCESS });

      if (updateDraft) {
        dispatch({ data: response.data, type: CONTENT_SET_DRAFT });
      }
    } catch (error) {
      dispatch(fetchContentByIdError());
    }
  };
}

export function setContentDraft(content) {
  return async (dispatch) => {
    try {
      dispatch({ data: { content }, type: CONTENT_SET_DRAFT });
    } catch (error) {
      dispatch(fetchContentError());
    }
  };
}
